import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FullScreenLoader from '@/components/FullScreenLoader';

const LoadingTransition = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract destination and options from state
  const { to, options } = (location.state as { to?: string; options?: any }) || { to: '/home' };

  useEffect(() => {
    // Artificial delay to ensure user sees the loader
    const timer = setTimeout(() => {
      // Use replace: true to avoid the loading page staying in history
      navigate(to || '/home', { ...options, replace: true });
    }, 600);

    return () => clearTimeout(timer);
  }, [navigate, to, options]);

  return <FullScreenLoader loading={true} />;
};

export default LoadingTransition;
